export default "__VITE_ASSET__BV$KE0nt__"